export var getSDKSrc = function getSDKSrc(_ref) {
  var site = _ref.site,
    siteId = _ref.siteId,
    widgetId = _ref.widgetId;
  var url = new URL("/csm/widget/script.js", "https://".concat(site));
  if (siteId) {
    url.searchParams.set('siteId', siteId);
    url.searchParams.set('site', site);
  }
  if (widgetId) {
    url.searchParams.set('widgetId', widgetId);
  }
  return url.toString();
};